import styled from 'styled-components';

// used to push the footer to the bottom of the page when there is little content
export const PageContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
